import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/nutrackx.png";
import { useDispatch, useSelector } from "react-redux";
import { LoginSuccess } from "../../redux/userSlice";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import hide from '../../assets/remove.svg'
import show from '../../assets/show.svg'
import { postRequest } from "../../utils/APICall";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { users } = useSelector((state) => state.user || {});

  // const urlParams = new URLSearchParams(window.location.href.split("?")[1]);
  // const token = urlParams.get("token");

  // useEffect(() => {
  //   const verifyToken = async () => {
  //     if (urlParams.size) {
  //       try {
  //         const response = await axios.get("https://nubitsoft-backend.vercel.app/user/verifyToken", {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             "Content-Type": "application/json",
  //           },
  //         });
  //         if (response.data.status) {
  //           dispatch(LoginSuccess(response.data.data));
  //           navigate("/");
  //         }
  //       } catch (error) {
  //         console.log(error.response.data.data);
  //       }
  //     }
  //   };
  //   verifyToken();
  // }, [token]);

    const validationSchema = Yup.object({
    email: Yup.string().required("Username or Email is required"),
    password: Yup.string().min(1, "Password must be at least 1 characters").required("Password is required"),
  });
  

  const handleLogin = async (values, { setSubmitting }) => {
   const payload = {
      email : values.email.trim(),
      password : values.password
    }
    try {
      const response =  await postRequest("login",payload)
      // console.log("response->>>>>",response) 
      if (response?.status) {
        dispatch(LoginSuccess(response?.data));
        
        // navigate("/");
        toast.success(response.message, { autoClose: 2000 });
      } else {
        toast.error(response.message, { autoClose: 2000 });
      }
    } catch (error) {
      toast.error(error.message, { autoClose: 2000 });
    }
    setSubmitting(false);
  };
  //  useEffect(()=>{
  // const isAuth = users?.ROLE_TITLE == "HR" || users?.ROLE_TITLE == "Admin" || users?.ROLE_TITLE == "Accountant"
  //   // console.log(isAuth)
  //   if(!isAuth){
  //     navigate('/login')
  //   }
  //  },[])



  return (
    <div className="flex justify-center items-center min-h-screen bg-white relative overflow-hidden">
      {/* Animated Rings */}
      {/* <div className="absolute w-[500px] h-[500px] flex justify-center items-center z-0">
        <i className="absolute inset-0 border-2 border-[#677293] drop-shadow-[20px_20px_20px_#677293] rounded-[38%_62%_63%_37%/41%_44%_56%_59%] animate-spin-slow transition-all duration-500" />
        <i className="absolute inset-0 border-2 border-[#33358E] drop-shadow-[20px_20px_20px_#33358E] rounded-[41%_44%_56%_59%/38%_62%_63%_37%] animate-spin-medium transition-all duration-500" />
        <i className="absolute inset-0 border-2 border-[#ED7A61] drop-shadow-[20px_20px_20px_#ED7A61] rounded-[41%_44%_56%_59%/38%_62%_63%_37%] animate-spin-reverse transition-all duration-500" />
      </div> */}

      {/* Login Box */}
      <div className=" card relative z-10 w-full max-w-md bg-black/5 backdrop-blur-md p-10 rounded-3xl shadow-lg border border-black/20 text-black ">
        <div className="flex justify-center mb-6">
          <div className="h-28 w-28 rounded-full overflow-hidden border-4 bg-white shadow-lg">
            <img src={logo} alt="Logo" className="h-full w-full object-cover" />
          </div>
        </div>
        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={validationSchema}
          onSubmit={handleLogin}
        >
          {({ isSubmitting }) => (
            <Form className="space-y-6">
              <div>
                <Field
                  type="text"
                  name="email"
                  placeholder="Username or  Email"
                  className="w-full px-4 py-3 bg-transparent border border-black/30 rounded-xl text-black placeholder-black/50 focus:outline-none focus:ring-2 focus:ring-[#ED7A61]"
                />
                <ErrorMessage name="email" component="div" className="text-red-600 text-sm mt-1" />
              </div>
              <div className="relative">
                <Field
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Password"
                  className="w-full px-4 py-3 bg-transparent border border-black/30 rounded-xl text-black placeholder-black/50 focus:outline-none focus:ring-2 focus:ring-[#ED7A61]"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-3 text-black text-xl"
                >
                  <img
                    src={showPassword ? hide : show}
                    alt={showPassword ? "Hide Password" : "Show Password"}
                    className="w-6 h-6"
                  />
                </button>
                <ErrorMessage name="password" component="div" className="text-red-600 text-sm mt-1" />
              </div>
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full py-3 rounded-xl font-semibold text-white bg-gradient-to-r from-[#ED7A61] to-[#33358E] hover:scale-105 transition-transform duration-300 disabled:opacity-60"
              >
                {isSubmitting ? "Logging in..." : "Login"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
      <ToastContainer />
    </div>
  );

};

export default Login;
